import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const CATEGORY_LABELS = {
  bk_student: "BK Student",
  bk_teacher_insured: "BK Teacher (Insured)",
  bk_teacher_no_insurance: "BK Teacher (No Insurance)",
};

export const ORDER_STATUS_LABELS = {
  pending: "Pending",
  prescription_received: "Prescription Received",
  pending_review: "Pending Review",
  approved: "Approved",
  quotation_sent: "Quotation Sent",
  customer_approved: "Customer Approved",
  payment_pending: "Payment Pending",
  payment_received: "Payment Received",
  packed: "Packed",
  shipped: "Shipped",
  scheduled: "Scheduled",
  sample_collected: "Sample Collected",
  report_ready: "Report Ready",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export const FBC_STATUS_LABELS = {
  not_availed: "Not Availed",
  pending: "Pending",
  booked: "Booked",
  sample_collected: "Sample Collected",
  completed: "Completed",
};

export const ENROLLMENT_STATUS_LABELS = {
  pending: "Pending",
  documents_pending: "Documents Pending",
  under_verification: "Under Verification",
  approved: "Approved",
  rejected: "Rejected",
  expired: "Expired",
  suspended: "Suspended",
};

export const PAYMENT_STATUS_LABELS = {
  pending: "Pending",
  paid: "Paid",
  failed: "Failed",
  refunded: "Refunded",
};

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
